const testingConstants = {
  meetingChatSidebarLoading: 'meetingChatSidebarLoading',
  chatLoaded: 'chatLoaded',
  chatInitializationError: 'chatInitializationError',
  feedbackForm: 'feedbackForm',
  joinBtn: 'joinBtn',
  tosCheckbox: 'tosCheckbox',
  roomActionsBlock: 'roomActionsBlock',
  createRoomButton: 'createRoomButton',
  kickButton: 'kickButton',
  roomTitle: 'roomTitle',
  chatInput: 'chatInput',
  sendChatMessageButton: 'sendChatMessageButton',
  messageSender: 'messageSender',
  chatMessage: 'chatMessage',
  openChatButton: 'openChatButton',
  endCallPopupCloseBtn: 'endCallPopupCloseBtn',
  leaveMeeting: 'leaveMeeting',
  copyButton: 'copyButton',
  copyButtonIcon: 'copyButtonIcon',
  joinEnterName: 'joinEnterName',
  openSidebarButton: 'openSidebarButton',
  raiseHandToastClose: 'raiseHandToastClose',
  raiseHandIndicator: 'raiseHandIndicator',
  createRoomModal: 'createRoomModal',
  submitFormButton: 'submitFormButton',
  raiseHandButton: 'raiseHandButton',
  hangUpButton: 'hangUpButton',
  peopleSidebarButton: 'peopleSidebarButton',
  confirmKick: 'confirmKick',
  raiseHandToast: 'raiseHandToast',
  optionsDropdown: 'optionsDropdown',
  addParticipantsModal: 'addParticipantsModal',
  autoRemindersModal: 'autoRemindersModal',
  reviewRoomStepModal: 'reviewRoomStepModal',
};

export default testingConstants;
